// extracted by mini-css-extract-plugin
export default {"container":"MakeImage_container__XCPlX"};